// Ensure old Safari browsers
// & IOS devices in private mode
// doesn't throw any errors
const isSupported = () => {
  try {
    localStorage.setItem('__test__', true)
    localStorage.removeItem('__test__')
    return true
  } catch (err) {
    return false
  }
}

const set = (key, value) => isSupported() && localStorage.setItem(key, value)
const get = key => isSupported() && localStorage.getItem(key)
const remove = key => isSupported() && localStorage.removeItem(key)
const clear = () => isSupported() && localStorage.clear()

export default {
  set,
  get,
  clear,
  remove,
}
